import React, { useState, useEffect } from 'react';
const ZipIcon = (props) => {
    const [id, setId] = useState(`${Math.random()}`);
    useEffect(() => {
        const id = `${Math.random()}`;
        setId(id);
    }, []);
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M4.66667 0H16.6667L22 5.33333V21.3333C22 22.8061 20.8061 24 19.3333 24H4.66667C3.19391 24 2 22.8061 2 21.3333V2.66667C2 1.19391 3.19391 0 4.66667 0Z", fill: `url(#${id})` }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.33301 6.66663H11.9997V9.06641H14.6661V11.4664H11.9997V12.6667H14.6661V15.0667H11.9997V16.2667V16.2667V16.2669H14.6661V18.6669H11.9994V18.6667H9.33301V16.2667V16.2667V13.8667H11.9994V12.6667H9.33301V10.2667H11.9994V9.06663H9.33301V6.66663Z", fill: "white" }),
        React.createElement("path", { d: "M16.667 4V0L22.0003 5.33333H18.0003C17.2639 5.33333 16.667 4.73638 16.667 4Z", fill: "white", fillOpacity: "0.5" }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: id, x1: "12", y1: "0", x2: "12", y2: "24", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#E7B785" }),
                React.createElement("stop", { offset: "1", stopColor: "#C99864" })))));
};
export default ZipIcon;
